import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import api from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import { Preloader } from "@/components/Preloader";
import { Hero } from "@/components/sections/Hero";
import { Services } from "@/components/sections/Services";
import { Packages } from "@/components/sections/Packages";
import { About } from "@/components/sections/About";
import { WhyUs } from "@/components/sections/WhyUs";
import { Gallery } from "@/components/sections/Gallery";
import { Reviews } from "@/components/sections/Reviews";
import { AppointmentSection } from "@/components/sections/AppointmentSection";
import { ContactSection } from "@/components/sections/ContactSection";
import { Loader2 } from "lucide-react";

export default function Landing() {
  const [content, setContent] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [intro, setIntro] = useState(true);

  useEffect(() => {
    document.title = "Autoaufbereitung Berisha | Premium Fahrzeugaufbereitung in Dorsten";
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
    api.get("/reviews").then((r) => setReviews(r.data)).catch(() => {});
    const t = setTimeout(() => setIntro(false), 2400);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="bg-white">
      <AnimatePresence>{intro && <Preloader key="preloader" />}</AnimatePresence>

      {!content ? (
        <div className="min-h-screen flex items-center justify-center bg-white">
          <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
        </div>
      ) : (
        <>
          <Navbar phone={content.phone} />
          <Hero content={content} />
          <Services content={content} />
          <Packages content={content} />
          <About content={content} />
          <WhyUs content={content} />
          <Gallery content={content} />
          <Reviews reviews={reviews} />
          <AppointmentSection content={content} />
          <ContactSection content={content} />
          <Footer content={content} />
          <CookieBanner />
        </>
      )}
    </div>
  );
}
